import Box from "@mui/material/Box"
import { ReactNode } from "react"

/** Width of the narrow column every row ends in. */
export const PROPERTY_GUTTER_WIDTH = 30

interface Props {
    children: ReactNode
    /** what sits in the narrow column — the aspect-ratio lock, or nothing */
    gutter?: ReactNode
}

/**
 * A row of fields that ends in the same narrow column as every other row, like in Figma: it
 * holds the aspect-ratio lock next to the dimensions and stays empty elsewhere, so all the
 * fields line up one under another.
 */
const PropertyRow = ({ children, gutter }: Props) => (
    <Box display="flex" gap={1} alignItems="center">
        <Box flex={1} minWidth={0}>
            {children}
        </Box>
        <Box width={PROPERTY_GUTTER_WIDTH} flexShrink={0} display="flex" justifyContent="center">
            {gutter}
        </Box>
    </Box>
)

export default PropertyRow
